<template>
  <div class="BindCard">
    <Form :model="form" :rules="rules" v-model="regular">
      <div class="supportBox">
        <Input
          label="银行卡号"
          v-model="form.cardNum"
          :reg="rules.cardNum"
          :maxlength="30"
          labelWidth="90px"
          type="tel"
          placeholder="请输入Ⅰ类银行卡号"
        />
        <div class="bankSupport" @click="handleBankSupport()">支持银行</div>
        <bank-support
          :showBankProps="showBankProps"
          :banklist="banklist"
          @setShowBank="setShowBank"
        ></bank-support>
      </div>
      <Input
        label="手机号"
        type="tel"
        v-model="form.custMobile"
        :reg="rules.custMobile"
        labelWidth="90px"
        maxlength="11"
        placeholder="请输入银行预留手机号"
      />
      <message-code
        label="验证码"
        :reg="rules.randomPassword"
        placeholder="请输入验证码"
        v-model="form.randomPassword"
        :params="{
          cust_mobile: form.custMobile,
          biz_scene: '105324',
        }"
      ></message-code>
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="提交"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
    <self-popup v-model="ShowContent"></self-popup>
  </div>
</template>

<script>
import Input from '@/components/Input.vue';
import Form from '@/components/Form.vue';
import Button from '@/components/Button.vue';
import { mapState, mapMutations } from 'vuex';
import MessageCode from '@/components/MessageCode.vue';
import { rules } from '@/utils';
import BankSupport from './components/BankSupport.vue';

export default {
  name: 'BindCard',
  components: {
    Button,
    Input,
    Form,
    BankSupport,
    MessageCode,
  },
  data() {
    return {
      showBankProps: false,
      banklist: [],
      regular: false,
      loading: false,
      ShowContent: '',
      uuid: '',
      form: {
        cardNum: '',
        custMobile: '',
        randomPassword: '',
      },
      rules: {
        cardNum: rules.bankNumber,
        custMobile: rules.legalPhone,
        randomPassword: rules.captcha,
      },
    };
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },

  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    handleBankSupport() {
      this.showBankProps = true;
    },
    setShowBank() {
      this.showBankProps = false;
    },
    nextStep() {
      this.loading = true;
      this.regular = false;
      const params = {
        ...this.form,
        orderId: this.capitalAccount.orderId,
      };
      this.$api.CommonForms.addBindNewCard(params)
        .then(async (res) => {
          if (res.success) {
            this.uuid = res.data.uuid;
            await this.polling();
          } else {
            this.ShowContent = res.returnMessage;
            this.loading = false;
            this.regular = true;
          }
        })
        .catch((e) => {
          this.regular = true;
          this.ShowContent = e;
          this.loading = false;
        });
    },
    async polling() {
      let timer = '';
      const that = this;
      const params = {
        uuid: this.uuid,
        orderId: this.capitalAccount.orderId,
      };
      const FAILURE_STATUS = '0';
      const SUCCESS_STATUS = '1';
      const PROCESSING_STATUS = '2';
      await (function getBindNewCardQuery() {
        that.$api.CommonForms.getBindNewCardQuery(params).then((res) => {
          if (res.success) {
            clearInterval(timer);
            if (res.data.status === FAILURE_STATUS) {
              // 失败
              clearInterval(timer);
              that.ShowContent = res.data.ret_msg;
              that.loading = false;
              that.regular = true;
            } else if (res.data.status === SUCCESS_STATUS) {
              // 成功
              clearInterval(timer);
              that.$router.push(
                `/supermarket/v2/BindCardManage?orderId=${that.capitalAccount.orderId}`,
              );
              that.loading = false;
              that.regular = true;
            } else if (res.data.status === PROCESSING_STATUS) {
              // 银行处理中
              timer = setInterval(getBindNewCardQuery, 3000);
            }
          } else {
            that.loading = false;
            that.regular = true;
          }
        });
      }());
    },
  },
};
</script>
<style scoped>
.supportBox {
  position: relative;
}
.bankSupport {
  background: #fff;
  position: absolute;
  right: 16px;
  top: 10px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
}
.BindCard >>> .van-field__label {
  text-align: left;
}
.nextStep {
  margin-top: 16px;
}
.BindCard >>> .van-button--danger {
  color: #fff;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: none;
}
.BindCard >>> .van-field__body > input {
  width: 174px;
}
</style>
